/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { CircularProgress } from '@mui/material'

interface PropsType {
	style?: React.CSSProperties
	size?: string
}

export const CircleSpinner = (props: PropsType) => {
	return (
		<View css={[style, { ...props.style }]}>
			<CircularProgress className="spinner" size={props.size ?? '2rem'} />
		</View>
	)
}

const style = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100%',

	'.spinner': {
		margin: 'auto',
	},
})
